var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_vm._m(0),_c('h4',[_vm._v("找不到页面")]),_c('h6',[_vm._v("抱歉，你访问的页面不存在")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回到首页")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("@/assets/images/404@2x.png"),"alt":""}})])
}]

export { render, staticRenderFns }